// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    GetCallUdeskCustomerQuery,
    BaseResponseLinkedHashMapstringobject,
} from '../../../types';

/**
 * findUdeskCustomer
 *
 * @export
 * @tags 质检语音记录
 * @link [GET] /call/udesk/customer
 */
export function getCallUdeskCustomer(
    options: ApiOptions<never, GetCallUdeskCustomerQuery> & { params: GetCallUdeskCustomerQuery }
): Promise<BaseResponseLinkedHashMapstringobject> {
    return request<never, never, GetCallUdeskCustomerQuery>('/call/udesk/customer', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getCallUdeskCustomer',
    });
}

export const meta = [{ tags: ['质检语音记录'], path: '/call/udesk/customer', method: 'get' }];
